import { usePricingConfig } from "utils/context/PricingConfigContext";
import useProfileSettings from "./useProfileSettings";

function useConfig() {
  const [{ pricingConfigs }] = usePricingConfig();
  const { getCurrentDate } = useProfileSettings();
  
  function getPricingConfig(configKey: string) {
    const pricingConfig = pricingConfigs?.find(
      (c) => c.configKey === configKey
    );

    return pricingConfig;
  }

  function isPremiumVisible(isNewJacket: boolean, jacketIssueDate?: Date) {
    // CHECK IF JACKET IS NEW OR PENDING/FAILED
    if (isNewJacket || !jacketIssueDate)
      return isAfterPremiumEffectiveDate(getCurrentDate());

    // CHECK IF JACKET WAS ISSUED
    return isAfterPremiumEffectiveDate(jacketIssueDate);
  }

  function isAfterPremiumEffectiveDate(date: Date) {
    const premiumConfig = getPricingConfig("ShortFormPremiumEffectiveDate");
    if (!premiumConfig) return false;

    const premiumEffectiveDate = new Date(premiumConfig.configValue!);

    return (
      date.setHours(0, 0, 0, 0) > premiumEffectiveDate.setHours(0, 0, 0, 0)
    );
  }

  const getOPNConfig = (
    opnConfigKey: string,
    transactionType?: string,
    propertyType?: string,
    formType?: string | null,
    pricingRateType?: string,
  ) => {
    let allow = false;
    let deny = false;
    pricingConfigs?.filter(
        (pc) =>
          pc.configKey === opnConfigKey &&
          (!pc.transactionType || pc.transactionType === transactionType) &&
          (!pc.propertyType || pc.propertyType === propertyType) &&
          (!pc.formType || pc.formType === formType) &&
          (!pc.rateType || pc.rateType === pricingRateType)
      )?.map((pc) => {
        if (pc.configValue?.toLowerCase() === "allow") {
          allow = true;
        }

        if (pc.configValue?.toLowerCase() === "deny") {
          deny = true;
        }
      })

    return (allow && !deny);
  }  


  return {
    isPremiumVisible,
    getPricingConfig,
    getOPNConfig,
  };
}

export default useConfig;
